<template>
  <v-row justify="center" align="center">
    <v-col cols="12" lg="6">
      <v-card outlined flat>
        <v-card-title>
          {{ $t("analytics.onbording.rate_satisfaction") }}
        </v-card-title>
        <v-card-text v-if="dataSource.series[0].data.length">
          <MixedCarts :dataSource="dataSource" />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" lg="6">
      <v-card outlined flat>
        <v-card-title>
          {{ $t("analytics.onbording.create_request") }}
        </v-card-title>
        <v-card-text v-if="dataSource1.series[0].data.length">
          <MixedCarts :dataSource="dataSource1" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../../../charts/ApexCartsMixed.vue";
export default {
  name: "SatisfactionRequest",
  components: {
    MixedCarts,
  },
  data() {
    return {
      elements: ["message_end_yes", "message_end_no"],
      elements1: ["create_request_yes", "create_request_no"],
      dataSource: {
        type: "bar",
        height: 350,
        series: [
          {
            data: [],
          },
        ],
        chartOptions: {
          colors: ["#E91E63", "#33a5fc"],
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              barHeight: "85%",
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            theme: "dark",
          },
        },
      },
      dataSource1: {
        type: "bar",
        height: 350,
        series: [
          {
            data: [],
          },
        ],
        chartOptions: {
          colors: ["#E91E63", "#33a5fc"],
          chart: {
            type: "bar",
            height: 350,
          },
          plotOptions: {
            bar: {
              borderRadius: 5,
              barHeight: "85%",
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          tooltip: {
            theme: "dark",
          },
        },
      },
    };
  },
  computed: {
    onboarding() {
      const data = this.$store.state.analytics.onboarding;
      return data;
    },
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
  },
  mounted() {
    let res = [];
    let res1 = [];
    if (this.onboarding) {
      for (const [key, value] of Object.entries(this.onboarding)) {
        //// Set datasource
        if (this.elements.includes(key)) {
          res.push({
            x: this.store_config.i18n[this.$i18n.locale].buttons[key]
              ? this.store_config.i18n[this.$i18n.locale].buttons[key].split(
                  "&"
                )[0]
              : this.store_config.i18n[this.$i18n.locale].buttons[key] || key,
            y: value,
          });
        }
        //// Set datasource1
        if (this.elements1.includes(key)) {
          res1.push({
            x: this.store_config.i18n[this.$i18n.locale].buttons[key]
              ? this.store_config.i18n[this.$i18n.locale].buttons[key].split(
                  "&"
                )[0]
              : this.store_config.i18n[this.$i18n.locale].buttons[key] || key,
            y: value,
          });
        }
      }
      this.dataSource.series[0].data = res.sort(function (a, b) {
        return b.y - a.y;
      });
      this.dataSource1.series[0].data = res1.sort(function (a, b) {
        return b.y - a.y;
      });
    }
  },
};
</script>
